export default __webpack_public_path__ + "static/media/img_services01.be377d00.png";